import { Button, message, Modal, Space, Table, Tag, Tooltip } from 'antd'
import './contentTable.css'
import { Navigate, useNavigate } from 'react-router-dom'
import { forwardRef } from 'react'
import { useState } from 'react'
import { useImperativeHandle } from 'react'
import { deleteShare, getCategories } from '../../../../api/api'
import moment from 'moment/moment'

const ContentTable = forwardRef((props, ref) => {
  const [data, setData] = useState([])
  const columns = [
    {
      title: '内容编号',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: '内容标题',
      dataIndex: 'title',
      key: 'title',
      width: '20%',
      ellipsis: {
        showTitle: false,
      },
      render: (title) => (
        <Tooltip placement="topLeft" title={title}>
          {title}
        </Tooltip>
      ),
    },
    {
      title: '分类',
      key: 'category_name',
      dataIndex: 'category_name',
      ellipsis: {
        showTitle: false,
      },
      render: (category_name) => (
        <Tooltip placement="topLeft" title={category_name}>
          {category_name}
        </Tooltip>
      ),
    },
    {
      title: '是否部分可见',
      key: 'isPartiallyVisible',
      dataIndex: 'isPartiallyVisible',
    },
    {
      title: '浏览量',
      key: 'views',
      dataIndex: 'views',
    },
    {
      title: '发布时间',
      key: 'createdAt',
      width: '15%',
      dataIndex: 'createdAt',
      ellipsis: {
        showTitle: false,
      },
      render: (created_at) => (
        <Tooltip placement="topLeft" title={created_at}>
          {created_at}
        </Tooltip>
      ),
    },
    {
      title: '最后修改时间',
      key: 'updatedAt',
      width: '15%',
      dataIndex: 'updatedAt',
      ellipsis: {
        showTitle: false,
      },
      render: (updated_at) => (
        <Tooltip placement="topLeft" title={updated_at}>
          {updated_at}
        </Tooltip>
      ),
    },

    {
      title: '操作',
      key: 'action',
      fixed: 'right',
      render: (_, record) => (
        <Space size="middle">
          <a onClick={() => jumpToEditor(record)}>编辑</a>
          <a onClick={() => deleteContent(record.id)}>删除</a>
        </Space>
      ),
    },
  ]
  const switchIs = (num) => {
    switch (num) {
      case 0:
        return '否'
        break
      case 1:
        return '是'
        break
      default:
        break
    }
  }

   const findName = (list, target) => {
     for (let subList of list) {
       if (subList.ID === target) {
         return subList.Name
       }
       if (subList.SubCategories) {
         let res = findName(subList.SubCategories, target)
         if (res) return res
       }
     }
   }

  const changeData = async(data) => {
    const list = await getCategories({
      params: { type: 2 },
    });

    data.map((info, index) => {
      info.key = index
      info.isPartiallyVisible = switchIs(info.is_partially_visible)
      info.createdAt = moment(info.created_at).format('YYYY-MM-DD HH:mm:ss')
      info.updatedAt = moment(info.updated_at).format('YYYY-MM-DD HH:mm:ss') 

      //初始化cascader
        const name = findName(list.data.data.Categories, info.category_id)
        info.category_name = name
        // console.log('casacder name',name);
      return info
    })
    setData(data)
  }

  useImperativeHandle(ref, () => ({
    changeData,
  }))

  let navigate = useNavigate()
  const jumpToEditor = (info) => {
    //将本列的详细数据传递给编辑页面
    navigate('/newContent', { state: { state: 'edit', info: info } })
  }
  //删除数据的回调
  const deleteContent = (id) => {
    Modal.confirm({
      title: '请确认',
      //  icon: <ExclamationCircleOutlined />,
      content: '您确定要删除此内容吗？删除后不可恢复。',
      okText: '确认',
      cancelText: '取消',
      onOk: () => {deleteShare(id)
        .then((res) => {
          const newData = data.filter((item) => item.id !== id)
          setData(newData)
          message.success('删除内容成功！')
        })
        .catch((err) => console.log(err))
      }
    })

  }

  return (
    <div className="contentTable" style={{ marginBottom: '20px' }}>
      <Table
        columns={columns}
        dataSource={data}
        pagination={false}
        scroll={{
          x: 1400,
          y: 400,
        }}
      />
    </div>
  )
})

export default ContentTable
